module.exports = __webpack_public_path__ + "img/1f61e.440afc3.svg";